import { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import api, { formatApiErrorDetail } from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 py-16 bg-background">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.6 }}
        className="w-full max-w-sm"
      >
        <span className="overline text-primary">Admin access</span>
        <h2 className="mt-4 font-display font-bold text-3xl tracking-tight mb-4">
          Reset password
        </h2>

        {sent ? (
          <div data-testid="forgot-password-sent" className="space-y-6">
            <p className="font-body text-muted-foreground">
              If that email is registered, we've sent a link to reset your
              password. It expires in 1 hour.
            </p>
            <Link to="/admin/login" className="font-body text-sm text-primary underline">
              Back to sign in
            </Link>
          </div>
        ) : (
          <form data-testid="forgot-password-form" onSubmit={submit}>
            <p className="font-body text-muted-foreground mb-8">
              Enter your admin email and we'll send you a link to reset your
              password.
            </p>
            <div>
              <Label className="font-body text-sm mb-2 block">Email</Label>
              <Input
                data-testid="forgot-password-email"
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@navjeevan.com"
                className="h-12"
              />
            </div>
            <Button
              data-testid="forgot-password-submit"
              type="submit"
              disabled={loading}
              className="mt-8 w-full h-12 rounded-full bg-foreground text-background hover:bg-primary"
            >
              {loading ? "Sending..." : "Send reset link"}
            </Button>
            <Link
              to="/admin/login"
              className="mt-6 block text-center font-body text-sm text-muted-foreground underline"
            >
              Back to sign in
            </Link>
          </form>
        )}
      </motion.div>
    </div>
  );
}
